import { render, staticRenderFns } from "./LoaderBtn.vue?vue&type=template&id=8bc89854&lang=pug&"
import script from "./LoaderBtn.vue?vue&type=script&lang=js&"
export * from "./LoaderBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports